import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    POST_CAMPAIGN_OVERVIEW_API,
    GET_CAMPAIGN_OPTIONS_API,
    PUT_CAMPAIGN_ENABLE_API,
    DELETE_CAMPAIGN_API,
    GET_CAMPAIGN_API,
    POST_CAMPAIGN_API,
    PUT_CAMPAIGN_API,
} from '@Apis/apiPath';

/** 抵用券管理 API */
const useCampaignApi = () => {
    const Axios = useAxios();

    /**
     * 抵用券總覽（對應後端 CampaignOverviewRequestModel）
     * @param {object} params
     * @param {string} [params.keyword] 名稱關鍵字
     * @param {string|number} [params.sourceType] 發行來源（0 全部）
     * @param {string|number} [params.isEnabled] 上下架狀態（0 全部、1 下架、2 上架）
     * @param {number} [params.pageIndex] 頁碼
     * @param {number} [params.pageSize] 每頁筆數
     */
    const postCampaignOverviewApi = useCallback(async (params) => {
        return await Axios.post(POST_CAMPAIGN_OVERVIEW_API, {
            keyword: params?.keyword || '',
            sourceType: Number(params?.sourceType) || 0,
            isEnabled: Number(params?.isEnabled) || 0,
            pageIndex: Number(params?.pageIndex) || 1,
            pageSize: Number(params?.pageSize) || 20,
        });
    }, []);

    /**
     * 取得抵用券選項（發行來源、上下架、基準價）
     * @param {object} [params]
     * @param {boolean} [params.skipAll] 為 true 時發行來源與上下架不含「全部」
     */
    const getCampaignOptionsApi = useCallback(async (params) => {
        return await Axios.get(GET_CAMPAIGN_OPTIONS_API, params);
    }, []);

    /** 抵用券上下架 */
    const putCampaignEnableApi = useCallback(async (campaignID, enabled) => {
        return await Axios.put(PUT_CAMPAIGN_ENABLE_API(campaignID), { enabled });
    }, []);

    /** 刪除抵用券 */
    const deleteCampaignApi = useCallback(async (campaignID) => {
        return await Axios.delete(DELETE_CAMPAIGN_API(campaignID));
    }, []);

    /** 讀回抵用券編輯資料 */
    const getCampaignApi = useCallback(async (campaignID) => {
        return await Axios.get(GET_CAMPAIGN_API(campaignID));
    }, []);

    /** 新增抵用券，回傳新的抵用券 ID */
    const postCampaignApi = useCallback(async (params) => {
        return await Axios.post(POST_CAMPAIGN_API, params);
    }, []);

    /** 修改抵用券 */
    const putCampaignApi = useCallback(async (campaignID, params) => {
        return await Axios.put(PUT_CAMPAIGN_API(campaignID), params);
    }, []);

    return {
        postCampaignOverviewApi,
        getCampaignOptionsApi,
        putCampaignEnableApi,
        deleteCampaignApi,
        getCampaignApi,
        postCampaignApi,
        putCampaignApi,
    };
};

export default useCampaignApi;
